import { styled } from '@mui/material/styles';
import { Link, useParams } from 'react-router-dom';
import { Button } from '@mui/material';

const PREFIX = 'ExpiredToken';

const classes = {
  root: `${PREFIX}-root`,
  expired: `${PREFIX}-expired`,
};

const Root = styled('div')({
  [`&.${classes.root}`]: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    paddingTop: '200px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  [`& .${classes.expired}`]: {
    width: '200px',
    borderRadius: '2rem',
  },
});

export const ExpiredToken = () => {
  const { trackingCode } = useParams();

  return (
    <Root className={classes.root}>
      <p>No token found! Please redeem new one.</p>
      <Button className={classes.expired} variant="contained" color="primary" component={Link} to={`/${trackingCode}`} disableElevation>
        Ok
      </Button>
    </Root>
  );
};
